import React, { Component } from 'react'
import AutoBind from 'react-autobind';
import { Link } from 'react-router-dom';
import Routes from '../../routes';
import Moment from 'Moment';
import { FormGroup } from './../../util/form-group/index';
import Modal from './../../util/modal/index';
import ReactSelect, { components }  from 'react-select';
import {
    Sucursal_Lista, ConsultaFacturaFiscal, Factura_Global, Factura_Fiscal_PDF_Listkey, Factura_Fiscal_XML_Listkey, Sucursal_Fiscal_ListKey,
    Forma_De_Pago_List, Cliente_Lista
} from '../../request/rfc';
import { defaultFormat } from 'moment';

const FormatDateUniversal = 'YYYY/MM/DD';
const FormatDateCR = 'DD/MM/YYYY';
const DefaultOptionsucursal = { Suc_Id: "0", Nombre: "Seleccionar un sucursal" }
const DefaultOptionCliente = { Cliente_Id: "0", Nombre: "Seleccionar un cliente" }
const DefaultOptionFormaPago = { Id: "0", Nombre: "Seleccionar una forma de pago" }

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

export default class Global extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            sucursal: 0,
            sucursales: [],
            fechaInicio: '',
            fechaFinal: '',
            selectedRow: {},
            serie: '',
            folio: '',
            folioUID: '',
            showModal: false,
            disabled: false,
            tipoFactura: '',
            anioFactura: 0,
            mesFactura: 0,
            formaPago: null,
            formasdePago: [],
            cliente: 0,
            clientes: []
        };
        localStorage.setItem("tipoFactura", '')
        AutoBind(this);
    }

    componentDidMount() {

        this.initTable([]);
        const $table = $(this.refs.tblFacturas);
        $table.on('click-row.bs.table', this.onClickTable);

        // get Sucursales 
        Sucursal_Lista()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ sucursales: [DefaultOptionsucursal, ...Data] });
                }
            })
            .catch((err) => { console.log(err); });
        Cliente_Lista()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ clientes: [DefaultOptionCliente, ...Data] });
                }
            })
            .catch((err) => { console.log(err); });

        Forma_De_Pago_List()
            .then(({ data: Response }) => {
                const { Message, Data } = Response
                if (Message !== '') {
                    alert(Message);
                } else {

                    
                   this.setState({ formasdePago: Data });
                }
            })
            .catch((err) => { console.log(err); });
    }

    componentWillUnmount() {
        // validar lo de las fechas, para destruir el componente
        $(document.getElementById('fechaInicio')).datepicker('destroy');
        $(document.getElementById('fechaFinal')).datepicker('destroy');
    }

    onChange(e) {

        const { name, value } = e.target;
        if (name === 'sucursal') {
            this.loadFiltros(value);
        }
        this.setState({ [name]: value });
    }

    loadFiltros(suc_Id) {
        Sucursal_Fiscal_ListKey(suc_Id)
            .then(({ data: Response }) => {
                const { Message, Data: fiscal } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({
                        tipoFactura: fiscal.Fiscal_Tipo_Global_id,
                        anioFactura: '0',
                        mesFactura: '0'
                    });
                    this.filtrosFactura();
                    localStorage.setItem("tipoFactura", fiscal.Fiscal_Tipo_Global_id)
                    if (fiscal.Fiscal_Tipo_Global_id === 'D') {

                        this.setState({
                            fechaInicio: Moment().subtract(7, 'days').format(FormatDateCR),
                            fechaFinal: Moment().format(FormatDateCR)
                        })
                        this.onchangeFechas();
                    } else {
                        this.setState({
                            fechaInicio: '',
                            fechaFinal: '',
                            anioFactura: 0,
                            mesFactura :0
                        })
                        
                    }

                    
                }
            })
            .catch((err) => { console.log(err); });

    }
    cargarFacturasGlobales(sucursal) {

        this.setState({ tipoFactura: localStorage.getItem("tipoFactura") })
        const arr = this.state.fechaInicio.split('/'); 
        var fecIni = arr[1] + '/' + arr[0] + '/' + arr[2];

        const arr2 = this.state.fechaFinal.split('/'); 
        var fecFin = arr2[1] + '/' + arr2[0] + '/' + arr2[2];
        if (this.state.tipoFactura === 'S' || this.state.tipoFactura === 'M') {
            this.state.fechaInicio = '01/01/1900';
            this.state.fechaFinal = '01/01/1900';
        }
        
        const { fechaInicio, fechaFinal, tipoFactura, anioFactura, mesFactura } = this.state;
        ConsultaFacturaFiscal({ pSucursal: sucursal, pFechaInicio: (fecIni === '' ? Moment().format('L') : fecIni), pFechaFinal: (fecFin === '' ? Moment().format('L') : fecFin), pTipoFactura: tipoFactura, pAnioFactura: anioFactura, pMesFactura: mesFactura })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const data = Data.map(item => Object.assign({}, item, { Fecha_Apertura: Moment(item.Fecha_Apertura).format(FormatDateCR) }));
                    this.initTable([]);

                    this.loadTable(data);
                }
            })
            .catch((err) => { console.log(err); });
    }

    onXMLDes() {
        this.setState({ disabled: true });
        const { selectedRow } = this.state;

        if (selectedRow.Fiscal_NumeroFacturaGlobal != '') {
            this.setState({ modalSucursal: true });
            Factura_Fiscal_XML_Listkey({ pSucursal: selectedRow.Suc_Id, pFolio: selectedRow.Fiscal_NumeroFacturaGlobal })
                .then(({ data: Response }) => {
                    const { Message, Data } = Response;
                    if (Message !== '') {
                        alert(Message);
                    } else {
                        const pdf = `data:application/octet-stream,${encodeURIComponent(Data.XML_Archivo)}`;
                        var element = document.createElement('a');
                        element.setAttribute('href', pdf);
                        element.setAttribute('download', `${Data.Fiscal_NumeroFactura}.xml`);
                        element.style.display = 'none';
                        document.body.appendChild(element);
                        element.click();
                        document.body.removeChild(element);
                    }
                })
                .catch((err) => { console.log(err); });
        }

    }

    initTable(data) {

        const $table = $(this.refs.tblFacturas);
        let _columnas = [];
        let _returns = '';

        if (this.state.tipoFactura === 'D') {
            _columnas = [{
                title: '# Operación',
                field: 'Operacion_id',
                sortable: true
            }, {
                title: 'Fecha Apertura',
                field: 'Fecha_Apertura'
            }, {
                title: '# Factura Fiscal',
                field: 'Fiscal_NumeroFacturaGlobal',
                sortable: true
                }
            ];

        }
        else if (this.state.tipoFactura === 'S') {
            _columnas = [{
                title: '# Semana',
                field: 'Semana',
                sortable: true
            }, {
                title: 'Operacion Inicial',
                field: 'Operacion_Inicial'
            }, {
                title: 'Operación Final',
                field: 'Operacion_Final',
                sortable: true
                }, {
                    title: 'Factura Fiscal',
                field: 'Fiscal_NumeroFacturaGlobal',
                    sortable: true
                }];

        }
        else if (this.state.tipoFactura === 'M') {
            _columnas = [{
                title: '# Mes',
                field: 'Mes',
                sortable: true
            }, {
                title: 'Operacion Inicial',
                field: 'Operacion_Inicial'
            }, {
                title: 'Operación Final',
                field: 'Operacion_Final',
                sortable: true
            }, {
                title: 'Factura Fiscal',
                field: 'Fiscal_NumeroFacturaGlobal',
                sortable: true
                }];
        }
        $table.bootstrapTable('destroy');

        $table.bootstrapTable({
            data: data || [],
            cache: false,
            height: 550,
            striped: false,
            pagination: true,
            sortable: true,
            locale: 'es-Ar',
            sortOrder: 'asc',
            showToggle: false,
            showPaginationSwitch: false,
            pageSize: 10,
            pageList: [10, 20, 30, 150, 250, 350, 500],
            search: true,
            toolbar: $('#toolbar'),
            toolbarAlign: 'right',
            showColumns: false,
            showRefresh: false,
            minimumCountColumns: 3,
            clickToSelect: true,
            rowAttributes: function (row) {

                if (row.Semana === 0 && row.Mes === 0) {
                    return { 'data-id': row.Operacion_id, 'data-genera': row.Fiscal_NumeroFacturaGlobal === '', 'data-suc': row.Suc_id }
                }
                else {
                    return { 'data-id': row.Operacion_Inicial, 'data-genera': row.Fiscal_NumeroFacturaGlobal === '', 'data-suc': row.Suc_id }
                }
                
               
            },
            columns: _columnas
        });
    }

    loadTable(data) {
        const $table = $(this.refs.tblFacturas);
        $table.bootstrapTable('load', data || []);

        
    }

    onSearch() {
        const { sucursal } = this.state;
        this.cargarFacturasGlobales(sucursal);
    }

    onAplicar() {
        this.setState({ disabled: true });
        const { sucursal, selectedRow, anioFactura, mesFactura, fechaFinal, tipoFactura, formaPago, cliente } = this.state;

        
        if (selectedRow.Fiscal_NumeroFacturaGlobal === '') {
            let _formasPago = '';
            if (formaPago === null) {
                //alert('Debe seleccionar uno o más formas de pago');
                //this.setState({ disabled: false });
                //return;
            }
            else {

                //-_formasPago = formaPago.map(f => f.value);
                for (const f of formaPago) {
                    _formasPago += f.value + ',';
                }
                _formasPago = _formasPago.substring(0, _formasPago.length - 1)
            }
            let _fecha = selectedRow.Fecha_Apertura;
            let operation = selectedRow.Operacion_id;

            if (selectedRow.Semana > 0 || selectedRow.Mes > 0) {
                operation = selectedRow.Operacion_Inicial + ',' + selectedRow.Operacion_Final;
            }
            if (tipoFactura === 'S' || tipoFactura === 'M') {
                _fecha = Moment(new Date(anioFactura, mesFactura, 1)).format('L');
            }
            Factura_Global({ pSucursal: sucursal, pOperacion: operation, pFecha: _fecha, pFormaPago: _formasPago, pCliente: cliente})
                .then(({ data: Response }) => {
                    const { Message, Data } = Response;
                    if (Message !== '') {
                        alert(Message);
                        this.setState({ disabled: false });
                    } else {
                        this.cargarFacturasGlobales(sucursal);
                        this.setState({
                            showModal: true, serie: Data.Serie, folio: Data.NumeroFactura,
                            folioUID: Data.UUID, modalSucursal: Data.Suc_Id, disabled: false
                        });
                    }
                })
                .catch((err) => { console.log(err); this.setState({ disabled: false }); });
        } else {
            this.setState({ disabled: false });
            alert('La operación ya fue facturada');
        }
    }

    onDescarga() {
        this.setState({ disabled: true });
        const { sucursal, selectedRow, anioFactura, mesFactura, fechaFinal, tipoFactura, formaPago, cliente } = this.state;
        if (selectedRow.Fiscal_NumeroFacturaGlobal != '') {
            this.setState({
                showModal: true, serie: 0, folio: selectedRow.Fiscal_NumeroFacturaGlobal, modalSucursal: selectedRow.Suc_id, disabled: false, folioUID: selectedRow.Fiscal_NumeroFacturaGlobal
            });
        } else {
            this.setState({ disabled: false });
            alert('La operación no facturada');
        }
        this.setState({ disabled: false });
    }

    onClickTable(row, $element, field) {
        const selectedRow = document.querySelector('tr.table-info');
        if (!!selectedRow)
            selectedRow.classList.remove('table-info');
        if ($element.Operacion_id > 0) {
            document.querySelector(`tr[data-id="${$element.Operacion_id}"]`).classList.add('table-info');
        }
        else {
            
            document.querySelector(`tr[data-id="${$element.Operacion_Inicial}"]`).classList.add('table-info');
        }
       
        this.setState({ selectedRow: $element });
    }

    onChangeSelectFormaPago = (selected) => {
        this.setState({ formaPago: selected });
        
    };
    onXML() {
        const { modalSucursal, folio } = this.state;
        Factura_Fiscal_XML_Listkey({ pSucursal: modalSucursal, pFolio: folio })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const pdf = `data:application/octet-stream,${encodeURIComponent(Data.XML_Archivo)}`;
                    var element = document.createElement('a');
                    element.setAttribute('href', pdf);
                    element.setAttribute('download', `${Data.Fiscal_NumeroFactura}.xml`);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
            })
            .catch((err) => { console.log(err); });
    }

    onPDF() {
        const { modalSucursal, folioUID } = this.state;
        Factura_Fiscal_PDF_Listkey({ pSucursal: modalSucursal, pFolio: folioUID })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const pdf = `data:application/pdf;base64,${encodeURIComponent(Data.Documento)}`;
                    var element = document.createElement('a');
                    element.setAttribute('href', pdf);
                    element.setAttribute('download', Data.Nombre);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
            })
            .catch((err) => { console.log(err); });
    }

   

    onCloseModal() {
        this.setState({ showModal: false });
    }

    onchangeFechas() {
        const fechaInicio = $(document.getElementById('fechaInicio'));
        const fechaFinal = $(document.getElementById('fechaFinal'));
        const dateOptions = { format: 'dd/mm/yyyy', autoclose: true, language: 'es' };

        fechaInicio.datepicker(dateOptions).on('changeDate', (e) => {
                fechaFinal.datepicker('setStartDate', e.date);
            this.setState({ fechaInicio: Moment(e.date).format(FormatDateCR) });
        });

        fechaFinal.datepicker(dateOptions).on('changeDate', (e) => {
                fechaInicio.datepicker('setEndDate', e.date);
            this.setState({ fechaFinal: Moment(e.date).format(FormatDateCR) });
        });


        fechaFinal.datepicker('setStartDate', Moment(new Date(this.state.fechaInicio)).format(FormatDateCR));
        fechaInicio.datepicker('setEndDate', Moment(new Date(this.state.fechaFinal)).format(FormatDateCR));


    }
    onChangeData(e)
    {
        const { name, value } = e.target

        if (name === 'anioFactura') {
            this.setState({ anioFactura: value })
        }

        if (name === 'mesFactura') {
            this.setState({ mesFactura: value })
        }     
    }
    filtrosFactura() {

        if (this.state.tipoFactura === '')
        {
            return null;
        }
   
        switch (this.state.tipoFactura) {
            case "D":

                return (
                    <div className="form-inline col-md-10" id="fechas">
                        <div className="form-group col-md-6">
                            <label>Fecha Inicial</label>
                            <input type="text" name="fechaInicio" id="fechaInicio" className="form-control datepicker" value={this.state.fechaInicio} onChange={this.onchangeFechas} readOnly />
                        </div>
                        <div className="form-group col-md-6">
                            <label>Fecha Final</label>
                            <input type="text" name="fechaFinal" id="fechaFinal" className="form-control" value={this.state.fechaFinal} onChange={this.onchangeFechas} readOnly  />
                        </div>
                    </div>
                );
            case "S":
                return (

                    <div className="form-inline col-md-10" id="mesAnio">
                        <div className="form-group col-md-6">
                            <label>Año</label>
                            <input type="number" name="anioFactura" id="anioFactura" className="form-control" min="0" value={this.state.anioFactura} onChange={this.onChangeData} onClick={this.removeClass} autoComplete="off" />
                        </div>

                        <div className="form-group col-md-6">
                            <label>Mes</label>
                            <input type="number" name="mesFactura" id="mesFactura" className="form-control" min="0" value={this.state.mesFactura} onChange={this.onChangeData} onClick={this.removeClass} autoComplete="off" />
                        </div>
                    </div>

                );
            case "M":
                return (
                    <div className="form-inline col-md-10">
                        <div className="form-group col-md-6">
                            <label>Año</label>
                            <input type="number" className="form-control" name="anioFactura" className="form-control" min="0" value={this.state.anioFactura} onChange={this.onChange} onClick={this.removeClass} autoComplete="off" />
                        </div>
                    </div>

                )
        }


    }

    removeClass() {
        
        const div = document.getElementsByClassName('datepicker datepicker-dropdown dropdown-menu datepicker-orient-left datepicker-orient-top');
        if (div[0] !== undefined) {
            div[0].remove();
    }         
    }
    render() {

        const { baseUrl, sucursal, sucursales, serie, folio, showModal, disabled, tipoFactura, fechaInicio, fechaFinal, formaPago, formasdePago, cliente, clientes } = this.state;
        const Options = sucursales.map(item => <option key={item.Suc_Id} value={item.Suc_Id}>{item.Nombre}</option>)
        const OptionsCliente = clientes.map(item => <option key={item.Id} value={item.Cliente_Id}>{item.Nombre}</option>)
        //const OptionsPago = formasdePago.map(item => ({ value: Id, label:Nombre }))
        const linkStyle = { 'pointerEvents': disabled ? 'none' : 'auto' };
        return (
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-12">
                            <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right" style={linkStyle}>
                                <i className="fas fa-angle-double-left"></i>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-11">
                            <label>Sucursales:</label>
                            <select name="sucursal" className="form-control" value={sucursal} onChange={this.onChange} disabled={disabled}>
                                {Options}
                            </select>
                        </div>

                    </div>
                    <div className="row">
                        <div className="form-group col-md-11">
                            <label>Cliente:</label>
                            <select name="cliente" className="form-control" value={cliente} onChange={this.onChange} disabled={disabled}>
                                {OptionsCliente}
                            </select>
                        </div>

                    </div>
                    <div className="row">
                        <div className="form-group col-md-11">
                            <label>Forma de Pago:</label>
                            <ReactSelect
                                options={formasdePago}
                                isMulti
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                components={{
                                    Option
                                }}
                                onChange={this.onChangeSelectFormaPago}
                                allowSelectAll={true}
                                value={this.state.formaPago}
                                placeholder= "Formas de pago"
                            />
                            {/*<Select name="formaPago" className="form-control" value={formaPago} onChange={this.onChange} disabled={disabled} option={formasdePago}></Select>*/}
                        </div>
                    </div>
                    <div className="row">
                        {
                            this.filtrosFactura()
                        }

                        
                        <div className="col-md-1">
                            <button type="button" className="btn btn-custom-theme margin-top-30" disabled={disabled} onClick={this.onSearch}>
                                <i className="fas fa-search"></i>
                            </button>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-12">
                            <table ref="tblFacturas"></table>
                        </div>
                    </div>
                </div>
                <div id="toolbar">
                    <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.onAplicar}>
                        <i className={disabled ? 'fas fa-spinner fa-spin' : 'fas fa-clipboard-check'}></i>
                    </button>
                    <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.onDescarga}>
                        <i >Descarga</i>
                    </button>
                </div>
                <Modal show={showModal}
                    serie={serie}
                    folio={folio}
                    onXML={this.onXML}
                    onPDF={this.onPDF}
                    onCloseModal={this.onCloseModal}
                />
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./Public/src/js/component/global/index.jsx